import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { MutationInputError } from 'providers/tanstack-query/errors'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { UPDATE_EMPLOYEE_FOR_TABLE } from './api/mutation'
import { Data } from './api/types'
import { UseUpdateEmployee, UseUpdateEmployeeProps, Variables } from './types'

export const useUpdateEmployee = ({ email }: UseUpdateEmployeeProps): UseUpdateEmployee => {
  const { t } = useTranslation('features/user')
  const { enqueueSnackbar } = useSnackbar()
  const [errors, setErrors] = useState<MutationInputError[]>([])

  const { mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: UPDATE_EMPLOYEE_FOR_TABLE,
    onCompleted: async (data: Data): Promise<void> => {
      const {
        updateEmployee: { errors },
      } = data

      if (errors) {
        setErrors(errors)
        enqueueSnackbar(t('list.update.error'), { variant: 'error' })
      } else {
        enqueueSnackbar(t('list.update.success', { email }), {
          variant: 'success',
        })
      }
    },
    queriesToInvalidate: ['getEmployeesForTable'],
  })

  const update = (variables: Variables): void => {
    void mutateAsync({
      input: variables,
    })
  }

  return { errors, update }
}
